<template>

    <templatesite>

        <template v-slot:appheader>  <appheader></appheader>  </template>
        <template v-slot:appsidebar>  <appsidebar></appsidebar> </template>
        <template v-slot:appcontent>

            <!-- Start::menu -->
            <appmenu></appmenu>
            <!-- end::menu -->

            <div class="content" style="margin-top: 0">
                <!-- Start::main-content -->
                <div class="main-content">

                    <!-- En-tête de page + actions -->
                    <div class="ds-page-head">
                        <div>
                            <h1 class="ds-page-head__title">
                                <i class="ri-dashboard-3-line"></i> Tableau de bord commercial
                            </h1>
                            <p class="ds-page-head__sub">Suivi des documents en cours</p>
                        </div>
                        <div class="cf-tool-grp">
                            <!--button @click="init" type="button" class="ti-btn bg-primary text-white btn-wave !font-medium !me-[0.375rem] !ms-0 !text-[0.85rem] !rounded-[0.35rem] !py-[0.51rem] !px-[0.86rem] shadow-none">
                                <i class="ri-refresh-fill  inline-block"></i>Actualiser
                            </button-->
                        </div>
                    </div>

                    <!-- KPIs principaux -->
                    <div class="tb-kpi-grid">

                        <div class="tb-kpi tb-kpi--warn">
                            <div class="tb-kpi__top">
                                <span class="tb-kpi__icon"><i class="ri-shopping-basket-2-fill"></i></span>
                                <span class="tb-kpi__tag">EN COURS</span>
                            </div>
                            <p class="tb-kpi__label">Demande d'achat en cours</p>
                            <h3 class="tb-kpi__value">{{nbredocdaf}}</h3>
                            <p class="tb-kpi__hint"><i class="ri-time-line"></i> Demandes non transformées</p>
                        </div>

                        <div class="tb-kpi tb-kpi--info">
                            <div class="tb-kpi__top">
                                <span class="tb-kpi__icon"><i class="ri-shopping-bag-3-fill"></i></span>
                                <span class="tb-kpi__tag">EN COURS</span>
                            </div>
                            <p class="tb-kpi__label">Bon de commande fournisseur en cours</p>
                            <h3 class="tb-kpi__value">{{nbredocbcf}}</h3>
                            <p class="tb-kpi__hint"><i class="ri-truck-line"></i> Commandes en attente</p>
                        </div>

                        <div class="tb-kpi tb-kpi--violet">
                            <div class="tb-kpi__top">
                                <span class="tb-kpi__icon"><i class="ri-inbox-archive-fill"></i></span>
                                <span class="tb-kpi__tag">EN COURS</span>
                            </div>
                            <p class="tb-kpi__label">Nombre de bon de réception en cours</p>
                            <h3 class="tb-kpi__value">{{nbredocbrf}}</h3>
                            <p class="tb-kpi__hint"><i class="ri-inbox-unarchive-line"></i> Réceptions en attente</p>
                        </div>

                        <div class="tb-kpi tb-kpi--primary">
                            <div class="tb-kpi__top">
                                <span class="tb-kpi__icon"><i class="ri-shopping-cart-fill"></i></span>
                                <span class="tb-kpi__tag">EN COURS</span>
                            </div>
                            <p class="tb-kpi__label">Bon de commande en cours</p>
                            <h3 class="tb-kpi__value">{{nbredocbc}}</h3>
                            <p class="tb-kpi__hint"><i class="ri-user-line"></i> Commandes clients en cours</p>
                        </div>

                        <div class="tb-kpi tb-kpi--success">
                            <div class="tb-kpi__top">
                                <span class="tb-kpi__icon"><i class="ri-box-3-fill"></i></span>
                                <span class="tb-kpi__tag">EN COURS</span>
                            </div>
                            <p class="tb-kpi__label">Bon de préparation de livraison en cours</p>
                            <h3 class="tb-kpi__value">{{nbredocbl}}</h3>
                            <p class="tb-kpi__hint"><i class="ri-archive-stack-line"></i> Préparations en cours</p>
                        </div>

                        <div class="tb-kpi tb-kpi--danger">
                            <div class="tb-kpi__top">
                                <span class="tb-kpi__icon"><i class="ri-bill-fill"></i></span>
                                <span class="tb-kpi__tag">À RÉGLER</span>
                            </div>
                            <p class="tb-kpi__label">Nombre de facture client en cours de payement</p>
                            <h3 class="tb-kpi__value">{{nbredocf}}</h3>
                            <p class="tb-kpi__hint"><i class="ri-money-euro-circle-line"></i> Factures à encaisser</p>
                        </div>

                    </div>

                    <!-- Tables de suivi -->
                    <div class="tb-tables-grid">

                        <!-- Bon de commande en cours -->
                        <div class="cf-card cf-card--flush">
                            <div class="tb-panel">
                                <div class="tb-panel-head">
                                    <div class="tb-panel-title">
                                        <i class="ri-shopping-bag-3-fill" style="color:#2563eb"></i>
                                        Bon de commande en cours
                                        <span class="cf-chip cf-chip--info">{{ datatablebcf.length }}</span>
                                    </div>
                                </div>

                                <div class="table-scroll-wrap tb-scroll">
                                    <table class="doc-table">
                                        <thead>
                                        <tr>
                                            <th class="th">N° DOC</th>
                                            <th class="th">FOURNISSEUR</th>
                                            <th class="th">N° BON</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <template v-if="datatablebcf.length">
                                            <tr class="table-row" v-for="(datavalue,index) in datatablebcf" :key="index">
                                                <td class="td" data-label="N° DOC  : "><span class="cf-docnum">{{ datavalue.numdoc }}</span></td>
                                                <td class="td" data-label="FOURNISSEUR  : ">{{ datavalue.nameclient }}</td>
                                                <td class="td" data-label="N° BON  : ">{{ datavalue.numbon }}</td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr>
                                                <td colspan="3">
                                                    <div class="empty-state">
                                                        <i class="ri-information-fill empty-state__icon" style="color:#2563eb"></i>
                                                        <p class="empty-state__title">Aucun enregistrement n'a été trouvé.</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                        </tbody>
                                    </table>
                                </div>

                                <!-- Pagination -->
                                <div class="cf-dialog-foot cf-dialog-foot--split tb-foot">
                                    <p class="cf-foot-info"><b>{{ datatablebcf.length }}</b> enregistrement(s)</p>
                                    <div class="pagination">
                                        <button :class="{ 'disabled': page <= 1 }" :disabled="page <= 1"
                                                class="page-btn page-btn--nav" @click="page--">
                                            <i class="ri-arrow-left-s-line"></i>
                                        </button>
                                        <button class="page-btn" :class="{ 'page-btn--active': pageNumber === page }"
                                                :key="key" v-for="(pageNumber, key) in displayedPages" @click="page = pageNumber">
                                            {{ pageNumber }}
                                        </button>
                                        <button :class="{ 'disabled': page >= pages.length }" :disabled="page >= pages.length"
                                                class="page-btn page-btn--nav" @click="page++">
                                            <i class="ri-arrow-right-s-line"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Facture fournisseur non réglée -->
                        <div class="cf-card cf-card--flush">
                            <div class="tb-panel">
                                <div class="tb-panel-head">
                                    <div class="tb-panel-title">
                                        <i class="ri-bill-fill cf-danger"></i>
                                        Facture non réglée
                                        <span class="cf-chip cf-chip--ko">{{ datatablefacturefournisseurnonreglee.length }}</span>
                                    </div>
                                </div>

                                <div class="table-scroll-wrap tb-scroll">
                                    <table class="doc-table">
                                        <thead>
                                        <tr>
                                            <th class="th">N° DOC</th>
                                            <th class="th">FOURNISSEUR</th>
                                            <th class="th">N° BON</th>
                                            <th class="th th--center">MONTANT RESTANT</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <template v-if="datatablefacturefournisseurnonreglee.length">
                                            <tr class="table-row" v-for="(datavalue,index) in datatablefacturefournisseurnonreglee" :key="index">
                                                <td class="td" data-label="N° DOC  : "><span class="cf-docnum">{{ datavalue.numdoc }}</span></td>
                                                <td class="td" data-label="FOURNISSEUR  : ">{{ datavalue.nameclient }}</td>
                                                <td class="td" data-label="N° BON  : ">{{ datavalue.numbon }}</td>
                                                <td class="td td--center" data-label="MONTANT RESTANT  : "><span class="cf-strong">{{ currencyFormatDE(datavalue.mtntttctrt) }}</span></td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr>
                                                <td colspan="4">
                                                    <div class="empty-state">
                                                        <i class="ri-checkbox-circle-fill empty-state__icon cf-ok"></i>
                                                        <p class="empty-state__title">Aucun enregistrement n'a été trouvé.</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                        </tbody>
                                    </table>
                                </div>

                                <!-- Pagination -->
                                <div class="cf-dialog-foot cf-dialog-foot--split tb-foot">
                                    <p class="cf-foot-info"><b>{{ datatablefacturefournisseurnonreglee.length }}</b> enregistrement(s)</p>
                                    <div class="pagination">
                                        <button :class="{ 'disabled': page <= 1 }" :disabled="page <= 1"
                                                class="page-btn page-btn--nav" @click="page--">
                                            <i class="ri-arrow-left-s-line"></i>
                                        </button>
                                        <button class="page-btn" :class="{ 'page-btn--active': pageNumber === page }"
                                                :key="key" v-for="(pageNumber, key) in displayedPages" @click="page = pageNumber">
                                            {{ pageNumber }}
                                        </button>
                                        <button :class="{ 'disabled': page >= pages.length }" :disabled="page >= pages.length"
                                                class="page-btn page-btn--nav" @click="page++">
                                            <i class="ri-arrow-right-s-line"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Bon de préparation de livraison en cours -->
                        <div class="cf-card cf-card--flush">
                            <div class="tb-panel">
                                <div class="tb-panel-head">
                                    <div class="tb-panel-title">
                                        <i class="ri-box-3-fill" style="color:#7c3aed"></i>
                                        Bon de préparation de livraison en cours
                                        <span class="cf-chip cf-chip--info">{{ datatablebpl.length }}</span>
                                    </div>
                                </div>

                                <div class="table-scroll-wrap tb-scroll">
                                    <table class="doc-table">
                                        <thead>
                                        <tr>
                                            <th class="th">N° DOC</th>
                                            <th class="th">CLIENT</th>
                                            <th class="th">N° BON</th>
                                            <th class="th th--center">QTE RESTANTE</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <template v-if="datatablebpl.length">
                                            <tr class="table-row" v-for="(datavalue,index) in datatablebpl" :key="index">
                                                <td class="td" data-label="N° DOC  : "><span class="cf-docnum">{{ datavalue.numdoc }}</span></td>
                                                <td class="td" data-label="FOURNISSEUR  : ">{{ datavalue.nameclient }}</td>
                                                <td class="td" data-label="N° BON  : ">{{ datavalue.numbon }}</td>
                                                <td class="td td--center" data-label="QTE RESTANTE  : "><span class="cf-badge cf-badge--muted">{{ datavalue.qterestant }}</span></td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr>
                                                <td colspan="4">
                                                    <div class="empty-state">
                                                        <i class="ri-information-fill empty-state__icon" style="color:#2563eb"></i>
                                                        <p class="empty-state__title">Aucun enregistrement n'a été trouvé.</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                        </tbody>
                                    </table>
                                </div>

                                <!-- Pagination -->
                                <div class="cf-dialog-foot cf-dialog-foot--split tb-foot">
                                    <p class="cf-foot-info"><b>{{ datatablebpl.length }}</b> enregistrement(s)</p>
                                    <div class="pagination">
                                        <button :class="{ 'disabled': page <= 1 }" :disabled="page <= 1"
                                                class="page-btn page-btn--nav" @click="page--">
                                            <i class="ri-arrow-left-s-line"></i>
                                        </button>
                                        <button class="page-btn" :class="{ 'page-btn--active': pageNumber === page }"
                                                :key="key" v-for="(pageNumber, key) in displayedPages" @click="page = pageNumber">
                                            {{ pageNumber }}
                                        </button>
                                        <button :class="{ 'disabled': page >= pages.length }" :disabled="page >= pages.length"
                                                class="page-btn page-btn--nav" @click="page++">
                                            <i class="ri-arrow-right-s-line"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Facture client non réglée -->
                        <div class="cf-card cf-card--flush">
                            <div class="tb-panel">
                                <div class="tb-panel-head">
                                    <div class="tb-panel-title">
                                        <i class="ri-bill-fill cf-danger"></i>
                                        Facture non réglée
                                        <span class="cf-chip cf-chip--ko">{{ datatablefactureclientnonreglee.length }}</span>
                                    </div>
                                </div>

                                <div class="table-scroll-wrap tb-scroll">
                                    <table class="doc-table">
                                        <thead>
                                        <tr>
                                            <th class="th">N° DOC</th>
                                            <th class="th">FOURNISSEUR</th>
                                            <th class="th">N° BON</th>
                                            <th class="th th--center">MONTANT RESTANT</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <template v-if="datatablefactureclientnonreglee.length">
                                            <tr class="table-row" v-for="(datavalue,index) in datatablefactureclientnonreglee" :key="index">
                                                <td class="td" data-label="N° DOC  : "><span class="cf-docnum">{{ datavalue.numdoc }}</span></td>
                                                <td class="td" data-label="FOURNISSEUR  : ">{{ datavalue.nameclient }}</td>
                                                <td class="td" data-label="N° BON  : ">{{ datavalue.numbon }}</td>
                                                <td class="td td--center" data-label="MONTANT RESTANT  : "><span class="cf-strong">{{ currencyFormatDE(datavalue.mtntttctrt) }}</span></td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr>
                                                <td colspan="4">
                                                    <div class="empty-state">
                                                        <i class="ri-checkbox-circle-fill empty-state__icon cf-ok"></i>
                                                        <p class="empty-state__title">Aucun enregistrement n'a été trouvé.</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                        </tbody>
                                    </table>
                                </div>

                                <!-- Pagination -->
                                <div class="cf-dialog-foot cf-dialog-foot--split tb-foot">
                                    <p class="cf-foot-info"><b>{{ datatablefactureclientnonreglee.length }}</b> enregistrement(s)</p>
                                    <div class="pagination">
                                        <button :class="{ 'disabled': page <= 1 }" :disabled="page <= 1"
                                                class="page-btn page-btn--nav" @click="page--">
                                            <i class="ri-arrow-left-s-line"></i>
                                        </button>
                                        <button class="page-btn" :class="{ 'page-btn--active': pageNumber === page }"
                                                :key="key" v-for="(pageNumber, key) in displayedPages" @click="page = pageNumber">
                                            {{ pageNumber }}
                                        </button>
                                        <button :class="{ 'disabled': page >= pages.length }" :disabled="page >= pages.length"
                                                class="page-btn page-btn--nav" @click="page++">
                                            <i class="ri-arrow-right-s-line"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </template>

    </templatesite>


    <modalopenform ref="modalopenform"  ></modalopenform>

</template>

<script>

    import templatesite from "@/components/template/apptemplate";
    import appheader from "@/components/template/appheader";
    import appsidebar from "@/components/template/appsidebar";
    import appmenu from "@/components/views/pages/gestioncommerciale/menu";


    import * as JwtService from "@/common/jwt.service";
    import {currencyFormatDE, randomString} from "@/allfunction";
    import modalopenform from "@/components/views/pages/stock/mvtstock/modal_openform";
    const axios =require('axios');


    export default {
        /* eslint-disable */
        name: "ewallet",
        components: {
            templatesite,
            appheader,
            appsidebar,
            appmenu,
            modalopenform,

        },
        watch: {
            searchword: function(newvalue,oldvalue){

                this.page=1

            },


        },

        computed:{

            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatablestockminimum(){

                let mvalue=this.datatablestockminimum;

                return this.paginate(mvalue) ;

            },
        },

        data() {
            return {
                searchword:"",
                datatablefindecontratpermannent:[],
                datatabledocday:[],
                datatablestockminimum:[],

                datatablefactureclientnonreglee:[],
                datatablefacturefournisseurnonreglee:[],
                datatablebpl:[],
                datatablebcf:[],

                nbredocdaf:0,
                nbredocbcf:0,
                nbredocbrf:0,
                nbredocbc:0,
                nbredocbpl:0,
                nbredocbl:0,
                nbredocf:0,



                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 50,
                Defaultpage: 1,
                DefaultperPage: 50,
                pages: [],

            };
        },
        methods: {

            currencyFormatDE(p1){
                var number=Number(p1)
                return currencyFormatDE(number)
            },

            btnopen(value){


                let titlemodal="Document "+value.numdoc

                let Item=value

                this.$refs.modalopenform.showupdate(titlemodal,"update",this.typedoc,Item,this.otherdata);

            },


            async loadcountdoc() {

                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egldsds74gescom8571714dfe/gescom/tb/count/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                await response
                    .then(response => {

                        if (response.data.success){

                            t.nbredocdaf=response.data.m.nbredocdaf;
                            t.nbredocbcf=response.data.m.nbredocbcf;
                            t.nbredocbrf=response.data.m.nbredocbrf;
                            t.nbredocbc=response.data.m.nbredocbc;
                            t.nbredocbpl=response.data.m.nbredocbpl;
                            t.nbredocbl=response.data.m.nbredocbl;
                            t.nbredocf=response.data.m.nbredocf;

                        }
                        else{
                            t.nbredocdaf=0;
                            t.nbredocbcf=0;
                            t.nbredocbrf=0;
                            t.nbredocbc=0;
                            t.nbredocbpl=0;
                            t.nbredocbl=0;
                            t.nbredocf=0;
                        }


                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez actualiser la page.",
                            "<b></b>")
                    )
                    .finally(() =>  this.$store.dispatch('lancerchargement',false))



            },

            async loadreturndoc($mtypdoc) {


                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egldsds74gescom8571714dfe/gescom/tb/doc/'+$mtypdoc+'/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                await response
                    .then(response => {

                        if (response.data.success){



                                if($mtypdoc==='FR'){
                                    t.datatablefacturefournisseurnonreglee=response.data.m
                                }

                                if($mtypdoc==='F'){
                                    t.datatablefactureclientnonreglee=response.data.m
                                }

                                if($mtypdoc==='BPL'){
                                    t.datatablebpl=response.data.m
                                }
                                if($mtypdoc==='BCF'){
                                    t.datatablebcf=response.data.m
                                }



                        }
                        else{

                        }


                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez actualiser la page.",
                            "<b></b>")
                    )
                    .finally(() =>  this.$store.dispatch('lancerchargement',false))



            },



            init(){
                this.loadcountdoc();
                this.loadreturndoc("FR");
                this.loadreturndoc("F");
                this.loadreturndoc("BPL");
                this.loadreturndoc("BCF");
                //this.inittableauelistedocday();



            },










            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },
        mounted() {

            this.loadcountdoc();
            this.loadreturndoc("FR");
            this.loadreturndoc("F");
            this.loadreturndoc("BPL");
            this.loadreturndoc("BCF");
            //this.inittableauelistedocday();
        }






    }
</script>

<style scoped>
    /* Charte cf-/ds- : tokens uniquement (light-only) — patrons repris de stock/tb.vue */

    /* KPIs principaux */
    .tb-kpi-grid {
        display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1rem; margin-bottom: 1rem;
    }
    @media (min-width: 1024px) { .tb-kpi-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
    .tb-kpi {
        position: relative; overflow: hidden; background: #fff;
        border: 1px solid var(--cf-border); border-left: 4px solid var(--cf-border);
        border-radius: var(--cf-radius); padding: 1rem 1.1rem;
        box-shadow: var(--cf-shadow-sm); transition: box-shadow 0.2s ease, transform 0.2s ease;
    }
    .tb-kpi:hover { box-shadow: var(--cf-shadow-md); transform: translateY(-2px); }
    .tb-kpi__top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.6rem; }
    .tb-kpi__icon {
        height: 44px; width: 44px; border-radius: var(--cf-radius-sm);
        display: inline-flex; align-items: center; justify-content: center; font-size: 1.4rem;
    }
    .tb-kpi__tag { font-size: 0.64rem; font-weight: 700; padding: 3px 10px; border-radius: 999px; letter-spacing: 0.03em; }
    .tb-kpi__label { font-size: 0.8rem; font-weight: 500; color: var(--cf-muted); margin: 0 0 0.15rem; }
    .tb-kpi__value { font-size: 2.1rem; font-weight: 800; color: var(--cf-ink-strong); margin: 0; line-height: 1.1; font-variant-numeric: tabular-nums; }
    .tb-kpi__hint { display: flex; align-items: center; gap: 0.25rem; font-size: 0.72rem; color: var(--cf-faint); margin: 0.5rem 0 0; }

    .tb-kpi--danger { border-left-color: #ef4444; }
    .tb-kpi--danger .tb-kpi__icon { background: #fee2e2; color: #dc2626; }
    .tb-kpi--danger .tb-kpi__tag  { background: #fef2f2; color: #dc2626; }
    .tb-kpi--warn { border-left-color: #f97316; }
    .tb-kpi--warn .tb-kpi__icon { background: #ffedd5; color: #ea580c; }
    .tb-kpi--warn .tb-kpi__tag  { background: #fff7ed; color: #ea580c; }
    .tb-kpi--info { border-left-color: #3b82f6; }
    .tb-kpi--info .tb-kpi__icon { background: #dbeafe; color: #2563eb; }
    .tb-kpi--info .tb-kpi__tag  { background: #eff6ff; color: #2563eb; }
    .tb-kpi--violet { border-left-color: #8b5cf6; }
    .tb-kpi--violet .tb-kpi__icon { background: #ede9fe; color: #7c3aed; }
    .tb-kpi--violet .tb-kpi__tag  { background: #f5f3ff; color: #7c3aed; }
    .tb-kpi--primary { border-left-color: rgb(var(--primary)); }
    .tb-kpi--primary .tb-kpi__icon { background: rgb(var(--primary) / 0.10); color: rgb(var(--primary)); }
    .tb-kpi--primary .tb-kpi__tag  { background: rgb(var(--primary) / 0.10); color: rgb(var(--primary)); }
    .tb-kpi--success { border-left-color: rgb(var(--success)); }
    .tb-kpi--success .tb-kpi__icon { background: rgb(var(--success) / 0.12); color: rgb(var(--success)); }
    .tb-kpi--success .tb-kpi__tag  { background: rgb(var(--success) / 0.12); color: rgb(var(--success)); }

    /* Grille des tables de suivi */
    .tb-tables-grid { display: grid; grid-template-columns: minmax(0, 1fr); gap: 1rem; }
    @media (min-width: 1280px) { .tb-tables-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }

    /* Carte de panneau */
    .cf-card--flush { padding: 0; overflow: hidden; }
    .tb-panel { padding: 1rem 1.1rem 0; }
    .tb-panel-head { display: flex; align-items: center; justify-content: space-between; gap: 0.75rem; flex-wrap: wrap; margin-bottom: 0.9rem; }
    .tb-panel-title { display: flex; align-items: center; gap: 0.5rem; font-size: 0.9rem; font-weight: 700; color: var(--cf-ink-strong); }

    /* Chips (compteurs) */
    .cf-chip { display: inline-flex; align-items: center; font-size: 0.72rem; font-weight: 600; padding: 0.15rem 0.6rem; border-radius: 999px; border: 1px solid var(--cf-border); background: #fff; color: var(--cf-ink); }
    .cf-chip--ko   { border-color: #fecaca; background: #fef2f2; color: #b91c1c; }
    .cf-chip--info { border-color: #bfdbfe; background: #eff6ff; color: #1d4ed8; }

    /* Table */
    .table-scroll-wrap { overflow: auto; }
    .tb-scroll { max-height: 420px; }
    .doc-table { width: 100%; text-align: left; border-collapse: collapse; min-width: 480px; }
    .th { position: sticky; top: 0; z-index: 2; padding: 0.7rem 1rem; font-weight: 600; font-size: 0.72rem; color: var(--cf-ink); background: var(--cf-surface-alt); border-bottom: 1px solid var(--cf-border); white-space: nowrap; letter-spacing: 0.02em; text-align: left; text-transform: uppercase; }
    .th--center { text-align: center; }
    .table-row { border-bottom: 1px solid var(--cf-surface-alt); transition: background-color 0.15s; }
    .table-row:hover { background: var(--cf-surface); }
    .td { padding: 0.6rem 1rem; font-size: 0.82rem; color: var(--cf-ink); vertical-align: middle; }
    .td--center { text-align: center; }
    .cf-strong { font-weight: 600; color: var(--cf-ink-strong); font-size: 0.82rem; margin: 0; }
    .cf-docnum { display: inline-flex; align-items: center; padding: 2px 9px; font-size: 0.78rem; font-weight: 600; color: rgb(var(--primary)); background: rgb(var(--primary) / 0.10); border-radius: var(--cf-radius-sm); font-family: ui-monospace, monospace; }
    .cf-danger { color: #dc2626; font-weight: 700; }
    .cf-ok { color: #16a34a; }

    /* Badges */
    .cf-badge { display: inline-flex; align-items: center; padding: 2px 9px; font-size: 0.72rem; font-weight: 600; border-radius: 999px; white-space: nowrap; }
    .cf-badge--muted { background: var(--cf-surface-alt); color: var(--cf-muted); }

    /* État vide */
    .empty-state { padding: 2.5rem 1.5rem; text-align: center; }
    .empty-state__icon { font-size: 40px; margin-bottom: 14px; display: block; }
    .empty-state__title { font-size: 0.95rem; font-weight: 600; color: var(--cf-ink-strong); margin: 0; }

    /* Pied / pagination */
    .cf-dialog-foot { display: flex; align-items: center; justify-content: flex-end; gap: 0.6rem; padding: 0.9rem 1.1rem; border-top: 1px solid var(--cf-border); background: var(--cf-surface); }
    .cf-dialog-foot--split { justify-content: space-between; flex-wrap: wrap; gap: 0.6rem; }
    .tb-foot { margin: 1rem -1.1rem 0; }
    .cf-foot-info { font-size: 0.78rem; color: var(--cf-muted); margin: 0; }
    .cf-foot-info b { color: rgb(var(--primary)); }
    .pagination { display: flex; align-items: center; gap: 4px; flex-wrap: wrap; }
    .page-btn { min-width: 30px; height: 30px; padding: 0 8px; border: 1px solid rgb(var(--input-border,203 213 225)); border-radius: var(--cf-radius-sm); background: #fff; color: var(--cf-ink); font-size: 0.78rem; font-weight: 600; cursor: pointer; transition: all 0.15s; }
    .page-btn:hover:not(:disabled) { border-color: rgb(var(--primary) / 0.35); background: var(--cf-surface); }
    .page-btn:disabled { opacity: 0.5; cursor: not-allowed; }
    .page-btn--nav { width: 34px; display: inline-flex; align-items: center; justify-content: center; }
    .page-btn--active { background: rgb(var(--primary)); border-color: rgb(var(--primary)); color: #fff; }
    .page-btn--active:hover:not(:disabled) { background: rgb(var(--primary)); color: #fff; }

    .tb-scroll::-webkit-scrollbar { width: 8px; height: 8px; }
    .tb-scroll::-webkit-scrollbar-track { background: #f1f5f9; border-radius: 10px; }
    .tb-scroll::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
    .tb-scroll::-webkit-scrollbar-thumb:hover { background: #94a3b8; }

    @media (max-width: 768px) {
        .tb-scroll { max-height: 320px; }
        .tb-kpi__value { font-size: 1.7rem; }
    }
</style>
